import { render, staticRenderFns } from "./TopDiagnosesWidget.vue?vue&type=template&id=1f278554&scoped=true&"
import script from "./TopDiagnosesWidget.vue?vue&type=script&lang=js&"
export * from "./TopDiagnosesWidget.vue?vue&type=script&lang=js&"
import style0 from "./TopDiagnosesWidget.vue?vue&type=style&index=0&id=1f278554&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f278554",
  null
  
)

export default component.exports